export default "__VITE_ASSET__e732ca8c__"